module.exports = "dist/videos/help/gradient-direction.mp4";